import { categories, footerNote, siteName } from '@/mocks/homeData';

export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <a href="#top" className="flex w-fit items-center gap-2 cursor-pointer">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-fire-line text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-lg font-black text-foreground-950">{siteName}</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">{footerNote}</p>
            <div className="mt-5 flex items-center gap-2 text-xs text-foreground-500">
              <i className="ri-shield-keyhole-line" aria-hidden="true"></i>
              证据留档 · 多源复核 · 存疑留白
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading text-sm font-bold text-foreground-950">按品类查看</h4>
            <ul className="mt-4 space-y-2.5">
              {categories.map((c) => (
                <li key={c.name}>
                  <a
                    href="#lei-xing"
                    className="flex items-center gap-2 text-sm text-foreground-600 transition-colors duration-200 hover:text-primary-600 cursor-pointer"
                  >
                    <i className={`${c.icon} text-xs`} aria-hidden="true"></i>
                    {c.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-heading text-sm font-bold text-foreground-950">重要说明</h4>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              今日爆料仅对已公开信息做留档与整理，标注核验进度，不对当事人作事实之外的定性。涉及隐私的敏感信息在展示前已做模糊处理。
            </p>
            <a
              href="#ru-kou"
              className="mt-5 inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 transition-colors duration-200 hover:text-primary-700 cursor-pointer"
            >
              有纠错或补充材料？点这里联系我们
              <i className="ri-arrow-right-up-line" aria-hidden="true"></i>
            </a>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-3 border-t border-background-200 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center">
          <p>© {new Date().getFullYear()} {siteName} · 今日爆料实锤证据、文件曝光、录音证据、合同截图、转账记录、邮件往来整理归档</p>
          <div className="flex items-center gap-4">
            <a href="#top" className="transition-colors duration-200 hover:text-primary-600 cursor-pointer">回到顶部</a>
            <a href="#hua-ti" className="transition-colors duration-200 hover:text-primary-600 cursor-pointer">话题墙</a>
          </div>
        </div>
      </div>
    </footer>
  );
}